import type { ReactNode } from "react";
import type { GridRowParams } from '@mui/x-data-grid-premium';
import type { User } from 'features/users/types';
import useUser from "features/auth/useUser";
import { compareIds } from "util/support";
import useActions from "features/users/useActions";
import type { ID } from "types";

export const useDeleteUser = ({ row }: GridRowParams<User>) => {
    const { deleteUser } = useActions();

    const { user } = useUser();

    const renderLabel = ({ prefix }: Readonly<{
        prefix?: ReactNode;
    }>) => `${prefix ? prefix : ''} ${[
        row.firstName,
        row.email
    ].join('-')}`;

    const getIsRowOwner = () => compareIds(row.coreId, user.coreId);

    const handleDeleteUser = (coreId: ID) => {
        const [request] = deleteUser(coreId);

        return request;
    };

    return {
        renderLabel,
        getIsRowOwner,
        deleteUser: handleDeleteUser
    };
};

export default useDeleteUser;
